import React, { useRef, useState } from 'react';
import { Container, Card, Form, Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Toast from './../Components/common/Toast.jsx';

import userService from './../Services/user';

const Register = () =>{
    const [toastMessage, setToastMessage] = useState('');

    const initialErrors = {
        email: false, name:false, password: false, confirmPassword: false
    };

    const [errors, setErrors] = useState(initialErrors);
    const emailRef = useRef(null);
    const nameRef = useRef(null);
    const passwordRef = useRef(null);
    const confirmPassRef = useRef(null);

    const handleChange = e => {
        e.preventDefault();
        const {name, value } = e.target;
        if(value && !initialErrors[name]) setErrors({...initialErrors, [name]: false});
        else if(!value && !initialErrors[name]) setErrors({...initialErrors, [name]: true});
    }
    
    const validation = () =>{
        let flag = true, email=false, name=false, password=false, confirmPassword=false;
        
        if(!emailRef.current.value || !/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(emailRef.current.value)) { flag = false; email = true}
        if(!nameRef.current.value) { flag = false; name = true}
        if(!passwordRef.current.value ) { flag = false; password = true}
        if(!confirmPassRef.current.value ) { flag = false; confirmPassword = true}

        if(passwordRef.current.value !== confirmPassRef.current.value ) {flag = false; password = true; confirmPassword = true}
        
        if(!flag) {
            setErrors({email, name, password, confirmPassword});
            return false;
        }

        if(!notAMachine()) {
            setToastMessage('Invalid Validation!');
            return false;
        }

        return true;
    }

    const notAMachine = ()=>{
        const a = Math.floor(Math.random()*20-10);
        let b = Math.floor(Math.random()*20-10);
        const op = Math.floor(Math.random()* 4);
        
        if (op ===3 && b === 0) b++;
        
        let result;
        
        switch (op){
            case 0: result = a + b; break 
            case 1: result = a - b; break 
            case 2: result = a * b; break 
            case 3: result = a / b; break
            default: break; 
        }

        const operationString = [' + ', ' - ', ' * ', ' / ']
        const userResult = prompt(`ARE YOU A MACHINE? \n\n Calculate:  (${a})  ${operationString[op]}  (${b})`);
        if(parseInt(userResult) === parseInt(result)) return true;
        return false;
    }

    const socialClick = async() =>{
        setToastMessage('Not Implemented yet');

    }
    const handleSubmit = async() =>{
        if(validation()){
            const res = await userService.Register({
                email: emailRef.current.value,
                name: nameRef.current.value,
                pass: passwordRef.current.value
            })
            if(res.success){
                emailRef.current.value = '';
                nameRef.current.value = '';
                passwordRef.current.value = '';
                confirmPassRef.current.value = '';
                setErrors(initialErrors);
                setToastMessage(`User ${emailRef.current.value} have been registed`);
            }else{
                setToastMessage(res.message);

            }
        }
    } 

    const handlePressEnter = e =>{
        if (e.key === 'Enter') handleSubmit()
    }

    return(
        <Container fluid className='p-0 m-0 d-flex justify-content-center align-content-center vh-100 w-100 flex-column' onKeyDown={handlePressEnter}>
            <Card className='shadow-sm border-radius align-self-center bg-secondary mw-50'  >
                <Card.Header className='bg-dark text-white d-flex justify-content-between'>
                    <span className='font-weight-bold'>e1maxChat</span>
                    <span>Register</span>
                </Card.Header>
                <Card.Body className='py-3 bg-white'>
                    <Row className=''>
                        <Col xs={7}>
                            <Form.Control 
                                type='email' 
                                placeholder='email' 
                                className='my-2' 
                                name='email' 
                                ref={emailRef}
                                isInvalid={errors.email}
                                onChange={handleChange}
                            />
                            <Form.Control 
                                type='text' 
                                placeholder='name' 
                                className='my-2' 
                                name='name' 
                                ref={nameRef}
                                isInvalid={errors.name}
                                onChange={handleChange}
                            />
                            <Form.Control
                                type='password' 
                                className='mb-2' 
                                placeholder='enter password' 
                                name='password' 
                                ref={passwordRef}
                                onChange={handleChange}
                                isInvalid={errors.password}
                            />

                            <Form.Control
                                type='password' 
                                className='mb-3' 
                                placeholder='confirm password' 
                                name='confirmPassword' 
                                ref={confirmPassRef}
                                onChange={handleChange}
                                isInvalid={errors.password}
                            />

                            <Row>
                                <Col className='d-flex justify-content-between'>
                                    <Button 
                                        variant='success' 
                                        className='font-weight-bold'
                                        onClick={handleSubmit}
                                        >
                                            Register
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col className='text-center d-flex flex-column pt-2'>
                       
                            <ButtonGroup className='justify-content-center'>
                                <Button variant='primary'><img src={require('./../images/facebook.png').default} width='30' alt='google' className='rounded-circle' onClick={socialClick}/></Button>
                                <Button variant='primary'><img src={require('./../images/google.png').default} width='30'alt='facebook' onClick={socialClick}></img></Button>
                            </ButtonGroup>
                       
                        <NavLink to='/login' className='text-muted text-center d-block mt-auto mb-2'>Back to Login</NavLink>
                        </Col>
                    </Row>

                    <div className='mt-3 text-muted small text-center'>e1maxSystems 2021</div>
                </Card.Body>
            </Card>
            <Toast message ={toastMessage} close={setToastMessage}/>
    </Container>
    )
}

export default Register;